import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useAdminTheme } from '../../contexts/AdminThemeContext';
import { useAuth } from '../../contexts/AuthContext';
import { marketingService, MarketingLink } from '../../services/marketingService';
import { AdminService, AdminUser } from '../../services/adminService';

// ─── Icon Components ──────────────────────────────────────────────────
const IconLink = () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" /></svg>;
const IconUsers = () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" /></svg>;
const IconCheck = () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
const IconCursor = () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122" /></svg>;
const IconPlus = () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>;
const IconCopy = () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" /></svg>;
const IconCopied = () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>;
const IconEdit = () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" /></svg>;
const IconDelete = () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>;
const IconDuplicate = () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" /></svg>;
const IconQR = () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" /></svg>;
const IconSearch = () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>;
const IconExport = () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" /></svg>;
const IconClose = () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>;
const IconRefresh = () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" /></svg>;
const IconExpand = () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>;
const IconCollapse = () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" /></svg>;

// ─── Badge Color Options ──────────────────────────────────────────────
const BADGE_COLORS = [
    { label: 'Blue', value: '#3b82f6', bg: 'bg-blue-500' },
    { label: 'Indigo', value: '#6366f1', bg: 'bg-indigo-500' },
    { label: 'Purple', value: '#8b5cf6', bg: 'bg-purple-500' },
    { label: 'Pink', value: '#ec4899', bg: 'bg-pink-500' },
    { label: 'Rose', value: '#f43f5e', bg: 'bg-rose-500' },
    { label: 'Orange', value: '#f59e0b', bg: 'bg-amber-500' },
    { label: 'Green', value: '#10b981', bg: 'bg-emerald-500' },
    { label: 'Teal', value: '#14b8a6', bg: 'bg-teal-500' },
    { label: 'Cyan', value: '#06b6d4', bg: 'bg-cyan-500' },
];

type ViewTab = 'links' | 'pilot-users';
type FilterStatus = 'all' | 'active' | 'inactive' | 'expired';

// ─── QR Code Generator (pure SVG, no library) ────────────────────────
const QRCodeModal: React.FC<{ url: string; label: string; onClose: () => void; isDark: boolean }> = ({ url, label, onClose, isDark }) => {
    const qrApiUrl = `https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=${encodeURIComponent(url)}`;
    return (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={onClose}>
            <div className={`rounded-2xl p-6 max-w-sm w-full shadow-2xl ${isDark ? 'bg-gray-800' : 'bg-white'}`} onClick={e => e.stopPropagation()}>
                <div className="flex items-center justify-between mb-4">
                    <h3 className="text-lg font-semibold">QR Code</h3>
                    <button onClick={onClose} className="p-1 rounded-lg hover:bg-gray-100"><IconClose /></button>
                </div>
                <p className={`text-sm mb-4 ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>{label}</p>
                <div className="flex justify-center mb-4">
                    <img src={qrApiUrl} alt="QR Code" className="rounded-xl border border-gray-200" width={250} height={250} />
                </div>
                <p className={`text-xs text-center font-mono break-all ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>{url}</p>
                <div className="mt-4 flex gap-2">
                    <a href={qrApiUrl} download={`qr-${label}.png`} className="flex-1 text-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors">
                        Download PNG
                    </a>
                    <button onClick={() => { navigator.clipboard.writeText(url); }} className={`px-4 py-2 text-sm font-medium rounded-lg border transition-colors ${isDark ? 'border-gray-600 text-gray-300 hover:bg-gray-700' : 'border-gray-300 text-gray-600 hover:bg-gray-50'}`}>
                        Copy URL
                    </button>
                </div>
            </div>
        </div>
    );
};

// ─── Main Component ───────────────────────────────────────────────────
const AdminMarketingPage: React.FC = () => {
    const { isDark } = useAdminTheme();
    const { currentUser } = useAuth();

    // State
    const [links, setLinks] = useState<MarketingLink[]>([]);
    const [pilotUsers, setPilotUsers] = useState<AdminUser[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [showCreateForm, setShowCreateForm] = useState(false);
    const [editingLink, setEditingLink] = useState<MarketingLink | null>(null);
    const [copiedId, setCopiedId] = useState<string | null>(null);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [viewTab, setViewTab] = useState<ViewTab>('links');
    const [searchTerm, setSearchTerm] = useState('');
    const [filterStatus, setFilterStatus] = useState<FilterStatus>('all');
    const [filterCampaign, setFilterCampaign] = useState('');
    const [expandedLinkId, setExpandedLinkId] = useState<string | null>(null);
    const [qrLink, setQrLink] = useState<MarketingLink | null>(null);
    const [showUtmSection, setShowUtmSection] = useState(false);
    const [refreshing, setRefreshing] = useState(false);
    const [userSearch, setUserSearch] = useState('');

    // Form state
    const [formLabel, setFormLabel] = useState('');
    const [formSlug, setFormSlug] = useState('');
    const [formBadgeText, setFormBadgeText] = useState('🚀 Pilot');
    const [formBadgeColor, setFormBadgeColor] = useState('#3b82f6');
    const [formMaxSignups, setFormMaxSignups] = useState(0);
    const [formDescription, setFormDescription] = useState('');
    const [formCampaign, setFormCampaign] = useState('');
    const [formExpiry, setFormExpiry] = useState('');
    const [formUtmSource, setFormUtmSource] = useState('');
    const [formUtmMedium, setFormUtmMedium] = useState('');
    const [formUtmCampaign, setFormUtmCampaign] = useState('');

    // Fetch data
    const fetchData = useCallback(async () => {
        try {
            setIsLoading(true);
            const [fetchedLinks, allUsers] = await Promise.all([
                marketingService.getMarketingLinks(),
                AdminService.getAllUsers(),
            ]);
            setLinks(fetchedLinks);
            setPilotUsers(allUsers.filter(u => u.signupSource));
        } catch (err) {
            console.error('Error fetching marketing data:', err);
            setError('Failed to load marketing data');
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => { fetchData(); }, [fetchData]);

    const handleRefresh = async () => {
        setRefreshing(true);
        await fetchData();
        setRefreshing(false);
    };

    // Auto-generate slug from label
    useEffect(() => {
        if (!editingLink) {
            setFormSlug(formLabel.toLowerCase().replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-').trim());
        }
    }, [formLabel, editingLink]);

    // Campaigns list
    const campaigns = useMemo(() => {
        const c = new Set(links.map(l => l.campaign).filter(Boolean));
        return Array.from(c) as string[];
    }, [links]);

    // Filtered links
    const filteredLinks = useMemo(() => {
        let result = [...links];
        if (searchTerm) {
            const q = searchTerm.toLowerCase();
            result = result.filter(l => l.label.toLowerCase().includes(q) || l.slug.toLowerCase().includes(q) || (l.campaign || '').toLowerCase().includes(q));
        }
        if (filterStatus !== 'all') {
            if (filterStatus === 'active') result = result.filter(l => l.isActive && (!l.expiresAt || l.expiresAt.toDate() > new Date()));
            else if (filterStatus === 'inactive') result = result.filter(l => !l.isActive);
            else if (filterStatus === 'expired') result = result.filter(l => l.expiresAt && l.expiresAt.toDate() <= new Date());
        }
        if (filterCampaign) result = result.filter(l => l.campaign === filterCampaign);
        return result.sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
    }, [links, searchTerm, filterStatus, filterCampaign]);

    // Filtered pilot users
    const filteredPilotUsers = useMemo(() => {
        if (!userSearch) return pilotUsers;
        const q = userSearch.toLowerCase();
        return pilotUsers.filter(u => (u.email || '').toLowerCase().includes(q) || (u.firstName || '').toLowerCase().includes(q) || (u.lastName || '').toLowerCase().includes(q) || (u.signupSource || '').toLowerCase().includes(q));
    }, [pilotUsers, userSearch]);

    // Stats
    const totalSignups = links.reduce((sum, l) => sum + l.signupCount, 0);
    const totalClicks = links.reduce((sum, l) => sum + (l.clickCount || 0), 0);
    const activeLinks = links.filter(l => l.isActive && (!l.expiresAt || l.expiresAt.toDate() > new Date())).length;
    const conversionRate = totalClicks > 0 ? ((totalSignups / totalClicks) * 100).toFixed(1) : '0.0';

    const resetForm = () => {
        setFormLabel(''); setFormSlug(''); setFormBadgeText('🚀 Pilot'); setFormBadgeColor('#3b82f6');
        setFormMaxSignups(0); setFormDescription(''); setFormCampaign(''); setFormExpiry('');
        setFormUtmSource(''); setFormUtmMedium(''); setFormUtmCampaign('');
        setEditingLink(null); setShowCreateForm(false); setShowUtmSection(false);
    };

    const flash = (msg: string, type: 'success' | 'error') => {
        type === 'success' ? setSuccess(msg) : setError(msg);
        setTimeout(() => { setSuccess(''); setError(''); }, 4000);
    };

    const handleCreateOrUpdate = async () => {
        if (!formLabel.trim() || !formSlug.trim()) { flash('Label and slug are required', 'error'); return; }
        try {
            if (editingLink) {
                await marketingService.updateLink(editingLink.id, {
                    label: formLabel, slug: formSlug, badgeText: formBadgeText, badgeColor: formBadgeColor,
                    maxSignups: formMaxSignups, description: formDescription, campaign: formCampaign,
                    expiresAt: formExpiry ? new Date(formExpiry) as any : null,
                    utmSource: formUtmSource, utmMedium: formUtmMedium, utmCampaign: formUtmCampaign,
                });
                flash('Link updated successfully!', 'success');
            } else {
                await marketingService.createLink({
                    label: formLabel, slug: formSlug, badgeText: formBadgeText, badgeColor: formBadgeColor,
                    maxSignups: formMaxSignups, createdBy: currentUser?.email || 'admin',
                    description: formDescription, campaign: formCampaign,
                    expiresAt: formExpiry ? new Date(formExpiry) : null,
                    utmSource: formUtmSource, utmMedium: formUtmMedium, utmCampaign: formUtmCampaign,
                });
                flash('Link created successfully!', 'success');
            }
            resetForm(); await fetchData();
        } catch (err: any) { flash(err.message || 'Failed to save link', 'error'); }
    };

    const handleEdit = (link: MarketingLink) => {
        setEditingLink(link); setFormLabel(link.label); setFormSlug(link.slug);
        setFormBadgeText(link.badgeText); setFormBadgeColor(link.badgeColor);
        setFormMaxSignups(link.maxSignups); setFormDescription(link.description || '');
        setFormCampaign(link.campaign || '');
        setFormExpiry(link.expiresAt ? new Date(link.expiresAt.seconds * 1000).toISOString().split('T')[0] : '');
        setFormUtmSource(link.utmSource || ''); setFormUtmMedium(link.utmMedium || ''); setFormUtmCampaign(link.utmCampaign || '');
        setShowUtmSection(!!(link.utmSource || link.utmMedium || link.utmCampaign));
        setShowCreateForm(true);
    };

    const handleDelete = async (id: string) => {
        if (!window.confirm('Delete this marketing link? Already-tagged users are not affected.')) return;
        try { await marketingService.deleteLink(id); flash('Link deleted', 'success'); await fetchData(); } catch (err: any) { flash(err.message, 'error'); }
    };

    const handleToggle = async (id: string) => {
        try { const s = await marketingService.toggleLinkActive(id); flash(`Link ${s ? 'activated' : 'deactivated'}`, 'success'); await fetchData(); } catch (err: any) { flash(err.message, 'error'); }
    };

    const handleDuplicate = async (link: MarketingLink) => {
        try { await marketingService.duplicateLink(link.id, `${link.slug}-copy`); flash('Link duplicated', 'success'); await fetchData(); } catch (err: any) { flash(err.message, 'error'); }
    };

    const handleCopyUrl = (link: MarketingLink) => {
        navigator.clipboard.writeText(marketingService.getSignupUrl(link));
        setCopiedId(link.id); setTimeout(() => setCopiedId(null), 2000);
    };

    const handleExportUsers = () => {
        const headers = ['Email', 'Name', 'Source', 'Badge', 'Joined'];
        const rows = filteredPilotUsers.map(u => [
            u.email || '', `${u.firstName || ''} ${u.lastName || ''}`.trim(), u.signupSource || '',
            u.signupSourceBadge || '', u.createdAt?.toDate?.()?.toISOString() || ''
        ]);
        const csv = [headers, ...rows].map(r => r.map(v => `"${v}"`).join(',')).join('\n');
        const blob = new Blob([csv], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a'); a.href = url; a.download = `pilot-users-${new Date().toISOString().split('T')[0]}.csv`; a.click();
        URL.revokeObjectURL(url);
    };

    const isExpired = (link: MarketingLink) => link.expiresAt && link.expiresAt.toDate() <= new Date();
    const getLinkStatus = (link: MarketingLink) => {
        if (isExpired(link)) return { text: 'Expired', color: 'text-red-500 bg-red-50' };
        if (!link.isActive) return { text: 'Inactive', color: 'text-gray-500 bg-gray-100' };
        if (link.maxSignups > 0 && link.signupCount >= link.maxSignups) return { text: 'Full', color: 'text-orange-500 bg-orange-50' };
        return { text: 'Active', color: 'text-green-600 bg-green-50' };
    };

    // ─── Card styling ─────────────────────────────────────────────
    const cardCls = `rounded-xl border transition-all duration-200 ${isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200 shadow-sm'}`;
    const inputCls = `w-full px-3 py-2 rounded-lg border text-sm transition-colors ${isDark ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400 focus:border-blue-400' : 'bg-white border-gray-300 text-gray-900 placeholder-gray-400 focus:border-blue-500'} focus:ring-2 focus:ring-blue-500/20 outline-none`;
    const labelCls = `block text-sm font-medium mb-1.5 ${isDark ? 'text-gray-300' : 'text-gray-700'}`;
    const mutedCls = isDark ? 'text-gray-400' : 'text-gray-500';
    const btnPrimary = 'px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors';
    const btnSecondary = `px-4 py-2 text-sm font-medium rounded-lg border transition-colors ${isDark ? 'border-gray-600 text-gray-300 hover:bg-gray-700' : 'border-gray-300 text-gray-600 hover:bg-gray-50'}`;
    const btnIcon = `p-1.5 rounded-lg transition-colors ${isDark ? 'hover:bg-gray-700 text-gray-400 hover:text-white' : 'hover:bg-gray-100 text-gray-400 hover:text-gray-700'}`;

    if (isLoading) {
        return (
            <div className="flex items-center justify-center h-64">
                <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-500"></div>
            </div>
        );
    }

    return (
        <div className={`p-6 max-w-7xl mx-auto space-y-6 ${isDark ? 'text-white' : 'text-gray-900'}`}>
            {/* Alerts */}
            {error && <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm animate-pulse">{error}</div>}
            {success && <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg text-sm">{success}</div>}

            {/* ─── Stats Cards ──────────────────────────────────────────── */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                {[
                    { label: 'Total Links', value: links.length, icon: <IconLink />, gradient: 'from-blue-500 to-indigo-600' },
                    { label: 'Total Signups', value: totalSignups, icon: <IconUsers />, gradient: 'from-emerald-500 to-teal-600' },
                    { label: 'Active Links', value: activeLinks, icon: <IconCheck />, gradient: 'from-purple-500 to-violet-600' },
                    { label: 'Conversion Rate', value: `${conversionRate}%`, icon: <IconCursor />, gradient: 'from-orange-500 to-amber-600' },
                ].map((stat) => (
                    <div key={stat.label} className={cardCls}>
                        <div className="p-5">
                            <div className="flex items-center justify-between mb-3">
                                <p className={`text-xs font-medium uppercase tracking-wider ${mutedCls}`}>{stat.label}</p>
                                <div className={`w-9 h-9 rounded-lg bg-gradient-to-br ${stat.gradient} flex items-center justify-center text-white`}>
                                    {stat.icon}
                                </div>
                            </div>
                            <p className="text-2xl font-bold">{stat.value}</p>
                        </div>
                    </div>
                ))}
            </div>

            {/* ─── Tab Bar + Actions ─────────────────────────────────────── */}
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                <div className={`inline-flex rounded-lg p-0.5 ${isDark ? 'bg-gray-800' : 'bg-gray-100'}`}>
                    {(['links', 'pilot-users'] as ViewTab[]).map(tab => (
                        <button key={tab} onClick={() => setViewTab(tab)}
                            className={`px-4 py-2 text-sm font-medium rounded-md transition-all ${viewTab === tab
                                ? `${isDark ? 'bg-gray-700 text-white' : 'bg-white text-gray-900 shadow-sm'}`
                                : `${isDark ? 'text-gray-400 hover:text-white' : 'text-gray-500 hover:text-gray-700'}`
                                }`}>
                            {tab === 'links' ? `Links (${links.length})` : `Pilot Users (${pilotUsers.length})`}
                        </button>
                    ))}
                </div>
                <div className="flex items-center gap-2">
                    <button onClick={handleRefresh} className={`${btnIcon} ${refreshing ? 'animate-spin' : ''}`} title="Refresh"><IconRefresh /></button>
                    {viewTab === 'links' && <button onClick={() => { resetForm(); setShowCreateForm(true); }} className={`${btnPrimary} flex items-center gap-1.5`}><IconPlus /> New Link</button>}
                    {viewTab === 'pilot-users' && pilotUsers.length > 0 && <button onClick={handleExportUsers} className={`${btnSecondary} flex items-center gap-1.5`}><IconExport /> Export CSV</button>}
                </div>
            </div>

            {/* ─── Search & Filter Bar ──────────────────────────────────── */}
            {viewTab === 'links' && (
                <div className={`${cardCls} p-3`}>
                    <div className="flex flex-wrap items-center gap-3">
                        <div className="relative flex-1 min-w-[200px]">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"><IconSearch /></div>
                            <input type="text" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} placeholder="Search links..."
                                className={`${inputCls} pl-9`} />
                        </div>
                        <select value={filterStatus} onChange={e => setFilterStatus(e.target.value as FilterStatus)}
                            className={`${inputCls} w-auto min-w-[120px]`}>
                            <option value="all">All Status</option>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                            <option value="expired">Expired</option>
                        </select>
                        {campaigns.length > 0 && (
                            <select value={filterCampaign} onChange={e => setFilterCampaign(e.target.value)}
                                className={`${inputCls} w-auto min-w-[140px]`}>
                                <option value="">All Campaigns</option>
                                {campaigns.map(c => <option key={c} value={c}>{c}</option>)}
                            </select>
                        )}
                    </div>
                </div>
            )}

            {viewTab === 'pilot-users' && (
                <div className={`${cardCls} p-3`}>
                    <div className="relative">
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"><IconSearch /></div>
                        <input type="text" value={userSearch} onChange={e => setUserSearch(e.target.value)} placeholder="Search pilot users by name, email, or source..."
                            className={`${inputCls} pl-9`} />
                    </div>
                </div>
            )}

            {/* ─── Create / Edit Modal ──────────────────────────────────── */}
            {showCreateForm && (
                <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-start justify-center p-4 pt-16 overflow-y-auto" onClick={() => resetForm()}>
                    <div className={`rounded-2xl max-w-2xl w-full shadow-2xl ${isDark ? 'bg-gray-800' : 'bg-white'}`} onClick={e => e.stopPropagation()}>
                        {/* Header */}
                        <div className="p-5 border-b border-gray-200 flex items-center justify-between">
                            <h2 className="text-lg font-semibold">{editingLink ? 'Edit Link' : 'Create New Link'}</h2>
                            <button onClick={resetForm} className={btnIcon}><IconClose /></button>
                        </div>
                        {/* Body */}
                        <div className="p-5 space-y-4 max-h-[70vh] overflow-y-auto">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div><label className={labelCls}>Link Label *</label><input type="text" value={formLabel} onChange={e => setFormLabel(e.target.value)} placeholder="e.g., Pilot Batch - Feb 2026" className={inputCls} /></div>
                                <div><label className={labelCls}>URL Slug *</label><input type="text" value={formSlug} onChange={e => setFormSlug(e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, ''))} placeholder="pilot-batch-feb-2026" className={`${inputCls} font-mono`} />
                                    {formSlug && <p className={`text-xs mt-1 ${mutedCls}`}>...signup?src={formSlug}</p>}
                                </div>
                            </div>
                            <div><label className={labelCls}>Description</label><textarea value={formDescription} onChange={e => setFormDescription(e.target.value)} placeholder="Optional notes about this link..." rows={2} className={inputCls} /></div>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                <div><label className={labelCls}>Campaign Tag</label><input type="text" value={formCampaign} onChange={e => setFormCampaign(e.target.value)} placeholder="e.g., launch-feb-2026" className={inputCls} /></div>
                                <div><label className={labelCls}>Max Signups <span className={`font-normal ${mutedCls}`}>(0 = ∞)</span></label><input type="number" min="0" value={formMaxSignups} onChange={e => setFormMaxSignups(parseInt(e.target.value) || 0)} className={inputCls} /></div>
                                <div><label className={labelCls}>Expiry Date</label><input type="date" value={formExpiry} onChange={e => setFormExpiry(e.target.value)} className={inputCls} /></div>
                            </div>

                            {/* Badge */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div><label className={labelCls}>Badge Text</label><input type="text" value={formBadgeText} onChange={e => setFormBadgeText(e.target.value)} className={inputCls} /></div>
                                <div>
                                    <label className={labelCls}>Badge Color</label>
                                    <div className="flex items-center gap-1.5 mt-1">
                                        {BADGE_COLORS.map(c => (
                                            <button key={c.value} onClick={() => setFormBadgeColor(c.value)} title={c.label}
                                                className={`w-7 h-7 rounded-full transition-transform ${formBadgeColor === c.value ? 'scale-110 ring-2 ring-offset-1 ring-blue-500' : 'hover:scale-105'}`}
                                                style={{ backgroundColor: c.value }} />
                                        ))}
                                    </div>
                                </div>
                            </div>

                            {/* Badge Preview */}
                            <div className={`p-3 rounded-lg ${isDark ? 'bg-gray-700/50' : 'bg-gray-50'}`}>
                                <p className={`text-xs font-medium mb-2 ${mutedCls}`}>PREVIEW</p>
                                <div className="flex items-center gap-2">
                                    <span className="text-sm">John Doe</span>
                                    <span className="inline-flex px-2 py-0.5 text-xs font-semibold rounded-full text-white" style={{ backgroundColor: formBadgeColor }}>{formBadgeText || 'Badge'}</span>
                                </div>
                            </div>

                            {/* UTM Section */}
                            <div>
                                <button onClick={() => setShowUtmSection(!showUtmSection)} className={`text-sm font-medium flex items-center gap-1.5 ${isDark ? 'text-blue-400' : 'text-blue-600'} hover:underline`}>
                                    {showUtmSection ? <IconCollapse /> : <IconExpand />} UTM Parameters
                                </button>
                                {showUtmSection && (
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3">
                                        <div><label className={labelCls}>utm_source</label><input type="text" value={formUtmSource} onChange={e => setFormUtmSource(e.target.value)} placeholder="e.g., twitter" className={inputCls} /></div>
                                        <div><label className={labelCls}>utm_medium</label><input type="text" value={formUtmMedium} onChange={e => setFormUtmMedium(e.target.value)} placeholder="e.g., social" className={inputCls} /></div>
                                        <div><label className={labelCls}>utm_campaign</label><input type="text" value={formUtmCampaign} onChange={e => setFormUtmCampaign(e.target.value)} placeholder="e.g., pilot-launch" className={inputCls} /></div>
                                    </div>
                                )}
                            </div>
                        </div>
                        {/* Footer */}
                        <div className="p-5 border-t border-gray-200 flex justify-end gap-3">
                            <button onClick={resetForm} className={btnSecondary}>Cancel</button>
                            <button onClick={handleCreateOrUpdate} className={btnPrimary}>{editingLink ? 'Save Changes' : 'Create Link'}</button>
                        </div>
                    </div>
                </div>
            )}

            {/* ─── QR Code Modal ────────────────────────────────────────── */}
            {qrLink && <QRCodeModal url={marketingService.getSignupUrl(qrLink)} label={qrLink.label} onClose={() => setQrLink(null)} isDark={isDark} />}

            {/* ─── Links Tab ────────────────────────────────────────────── */}
            {viewTab === 'links' && (
                <div className="space-y-3">
                    {filteredLinks.length === 0 ? (
                        <div className={`${cardCls} p-12 text-center`}>
                            <div className="w-14 h-14 mx-auto rounded-full bg-gray-100 flex items-center justify-center mb-3"><IconLink /></div>
                            <p className={`text-sm ${mutedCls}`}>{searchTerm || filterStatus !== 'all' ? 'No links match your filters.' : 'No marketing links yet. Create one to start tracking signups.'}</p>
                        </div>
                    ) : (
                        filteredLinks.map((link) => {
                            const status = getLinkStatus(link);
                            const expanded = expandedLinkId === link.id;
                            const fullUrl = marketingService.getSignupUrl(link);
                            return (
                                <div key={link.id} className={`${cardCls} overflow-hidden`}>
                                    {/* Main Row */}
                                    <div className="p-4 flex items-center gap-4">
                                        {/* Status Dot */}
                                        <div className={`w-2.5 h-2.5 rounded-full flex-shrink-0 ${link.isActive && !isExpired(link) ? 'bg-green-500' : isExpired(link) ? 'bg-red-400' : 'bg-gray-400'}`} />
                                        {/* Info */}
                                        <div className="flex-1 min-w-0">
                                            <div className="flex items-center gap-2 mb-0.5">
                                                <span className="text-sm font-semibold truncate">{link.label}</span>
                                                <span className={`text-[10px] font-medium px-1.5 py-0.5 rounded-full ${status.color}`}>{status.text}</span>
                                                <span className="inline-flex px-2 py-0.5 text-[10px] font-semibold rounded-full text-white" style={{ backgroundColor: link.badgeColor }}>{link.badgeText}</span>
                                                {link.campaign && <span className={`text-[10px] px-1.5 py-0.5 rounded-full ${isDark ? 'bg-gray-700 text-gray-300' : 'bg-gray-100 text-gray-600'}`}>{link.campaign}</span>}
                                            </div>
                                            <p className={`text-xs font-mono truncate ${mutedCls}`}>{fullUrl}</p>
                                        </div>
                                        {/* Stats */}
                                        <div className="hidden sm:flex items-center gap-5 flex-shrink-0">
                                            <div className="text-center"><p className="text-lg font-bold">{link.signupCount}</p><p className={`text-[10px] ${mutedCls}`}>signups</p></div>
                                            {link.maxSignups > 0 && <div className="text-center"><p className={`text-xs ${mutedCls}`}>{link.maxSignups - link.signupCount} left</p>
                                                <div className="w-16 h-1.5 rounded-full bg-gray-200 mt-1"><div className="h-full rounded-full bg-blue-500 transition-all" style={{ width: `${Math.min(100, (link.signupCount / link.maxSignups) * 100)}%` }} /></div>
                                            </div>}
                                        </div>
                                        {/* Actions */}
                                        <div className="flex items-center gap-1 flex-shrink-0">
                                            <button onClick={() => handleCopyUrl(link)} className={btnIcon} title="Copy URL">{copiedId === link.id ? <IconCopied /> : <IconCopy />}</button>
                                            <button onClick={() => setQrLink(link)} className={btnIcon} title="QR Code"><IconQR /></button>
                                            <button onClick={() => handleToggle(link.id)} className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${link.isActive ? 'bg-green-500' : isDark ? 'bg-gray-600' : 'bg-gray-300'}`}>
                                                <span className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white transition-transform ${link.isActive ? 'translate-x-4' : 'translate-x-1'}`} />
                                            </button>
                                            <button onClick={() => setExpandedLinkId(expanded ? null : link.id)} className={btnIcon}>{expanded ? <IconCollapse /> : <IconExpand />}</button>
                                        </div>
                                    </div>
                                    {/* Expanded Detail */}
                                    {expanded && (
                                        <div className={`px-4 pb-4 pt-0 border-t ${isDark ? 'border-gray-700 bg-gray-800/50' : 'border-gray-100 bg-gray-50/50'}`}>
                                            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 pt-3">
                                                <div><p className={`text-[10px] uppercase tracking-wider ${mutedCls}`}>Created</p><p className="text-sm mt-0.5">{link.createdAt?.toDate?.()?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) || 'N/A'}</p></div>
                                                <div><p className={`text-[10px] uppercase tracking-wider ${mutedCls}`}>Created By</p><p className="text-sm mt-0.5 truncate">{link.createdBy}</p></div>
                                                <div><p className={`text-[10px] uppercase tracking-wider ${mutedCls}`}>Last Signup</p><p className="text-sm mt-0.5">{link.lastSignupAt?.toDate?.()?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) || 'None yet'}</p></div>
                                                <div><p className={`text-[10px] uppercase tracking-wider ${mutedCls}`}>Expires</p><p className="text-sm mt-0.5">{link.expiresAt ? link.expiresAt.toDate().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : 'Never'}</p></div>
                                            </div>
                                            {link.description && <p className={`text-sm mt-3 ${mutedCls}`}>{link.description}</p>}
                                            {(link.utmSource || link.utmMedium || link.utmCampaign) && (
                                                <div className={`mt-3 flex flex-wrap gap-2`}>
                                                    {link.utmSource && <span className={`text-[10px] px-2 py-0.5 rounded-full ${isDark ? 'bg-gray-700 text-gray-300' : 'bg-blue-50 text-blue-700'}`}>src: {link.utmSource}</span>}
                                                    {link.utmMedium && <span className={`text-[10px] px-2 py-0.5 rounded-full ${isDark ? 'bg-gray-700 text-gray-300' : 'bg-purple-50 text-purple-700'}`}>med: {link.utmMedium}</span>}
                                                    {link.utmCampaign && <span className={`text-[10px] px-2 py-0.5 rounded-full ${isDark ? 'bg-gray-700 text-gray-300' : 'bg-green-50 text-green-700'}`}>cmp: {link.utmCampaign}</span>}
                                                </div>
                                            )}
                                            <div className="flex items-center gap-2 mt-3 pt-3 border-t border-gray-200">
                                                <button onClick={() => handleEdit(link)} className={`${btnSecondary} text-xs flex items-center gap-1`}><IconEdit /> Edit</button>
                                                <button onClick={() => handleDuplicate(link)} className={`${btnSecondary} text-xs flex items-center gap-1`}><IconDuplicate /> Duplicate</button>
                                                <button onClick={() => handleDelete(link.id)} className="px-3 py-1.5 text-xs font-medium rounded-lg border border-red-200 text-red-500 hover:bg-red-50 transition-colors flex items-center gap-1"><IconDelete /> Delete</button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        })
                    )}
                </div>
            )}

            {/* ─── Pilot Users Tab ──────────────────────────────────────── */}
            {viewTab === 'pilot-users' && (
                <div className={cardCls}>
                    {filteredPilotUsers.length === 0 ? (
                        <div className="p-10 text-center">
                            <div className="w-14 h-14 mx-auto rounded-full bg-gray-100 flex items-center justify-center mb-3"><IconUsers /></div>
                            <p className={`text-sm ${mutedCls}`}>{userSearch ? 'No users match your search.' : 'No pilot users yet. Share a marketing link to start tracking.'}</p>
                        </div>
                    ) : (
                        <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className={isDark ? 'bg-gray-800/50' : 'bg-gray-50'}>
                                    <tr>
                                        {['User', 'Badge', 'Source', 'Campaign', 'Joined'].map(h => (
                                            <th key={h} className={`px-5 py-3 text-left text-xs font-medium uppercase tracking-wider ${mutedCls}`}>{h}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody className={`divide-y ${isDark ? 'divide-gray-700' : 'divide-gray-100'}`}>
                                    {filteredPilotUsers.map(user => (
                                        <tr key={user.id} className={isDark ? 'hover:bg-gray-800/50' : 'hover:bg-gray-50'}>
                                            <td className="px-5 py-3">
                                                <div className="flex items-center gap-3">
                                                    <div className="w-8 h-8 rounded-full bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center text-white text-sm font-medium flex-shrink-0">
                                                        {user.email?.charAt(0).toUpperCase()}
                                                    </div>
                                                    <div>
                                                        <p className="text-sm font-medium">{user.firstName || ''} {user.lastName || ''}</p>
                                                        <p className={`text-xs ${mutedCls}`}>{user.email}</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="px-5 py-3"><span className="inline-flex px-2 py-0.5 text-xs font-semibold rounded-full text-white" style={{ backgroundColor: user.signupSourceBadgeColor || '#3b82f6' }}>{user.signupSourceBadge || '🚀 Pilot'}</span></td>
                                            <td className={`px-5 py-3 text-sm ${mutedCls}`}>{user.signupSourceLabel || user.signupSource}</td>
                                            <td className={`px-5 py-3 text-sm ${mutedCls}`}>{user.signupSourceCampaign || '—'}</td>
                                            <td className={`px-5 py-3 text-sm ${mutedCls}`}>{user.createdAt?.toDate?.()?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) || 'N/A'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default AdminMarketingPage;
